const shuttles = {
  shuttles: 'שאטלים',

  toast: {
    error: {
      badResponse: '[שאטלים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[שאטלים] עודכן בהצלחה',
      },
      delete: {
        default: '[שאטלים] נמחק בהצלחה',
      },
    },
  },

  create: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן ליצור שאטל',
    },
    successToast: {
      message: 'הצלחה! השאטל נוסף בהצלחה',
    },
  },

  edit: {
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן לעדכן שאטל',
    },
    successToast: {
      message: 'הצלחה! השאטל עודכן בהצלחה',
    },
  },

  createNew: 'הוסף',
  deleteBtn: 'מחק',

  deleteModal: {
    header: 'מחק שאטלים',
    body: 'אתה עומד למחוק {{num}} שאטלים.',
  },
  table: {
    headers: {
      id: 'מזהה',
      line: 'קו',
      direction: 'כיוון',
      weekdays: 'ימי השבוע',
      supplier: 'ספק',
      pax: 'נוסעים',
    },
    notAvailable: 'לא זמין',
    actions: {
      duplicate: 'שכפל',
      delete: 'מחק',
      export: 'ייצא',
    },
  },

  form: {
    header: {
      createShuttle: {
        title: 'שאטל חדש',
      },

      updateShuttle: {
        title: 'שאטל',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    info: {
      details: {
        header: {
          create: 'הוסף שאטל',
          edit: 'ערוך שאטל',
          information: 'מידע על השאטל',
        },
        shuttleBy: {
          flexibleTime: 'זמן גמיש',
          fixedTime: 'זמן קבוע',
        },
        fields: {
          unit: 'אתר',
          supplier: 'מופעל על ידי',
          hour1: 'מ-',
          hour2: 'אל',
          shuttleBy: 'שאטל על ידי',
          code: 'קוד',
          name: 'שם',
          area: 'אזור',
          line: 'קו',
          profile: 'פרופיל',
          direction: 'כיוון',
          weekDays: 'ימי השבוע',
          drivers: 'נהגים',
          pax: 'נוסעים',
          paymentType: 'סוג תשלום',
          routingType: 'סוג הפקה',
        },
        paymentTypeOptions: {
          free: 'חינם',
          opusCard: 'כרטיס OPUS',
          cashOnBoard: 'מזומן על הסיפון',
          correspondance: 'התכתבות',
        },
        routingTypeOptions: {
          dynamic: 'דינמי',
          demand: 'ביקוש',
          bus: 'אוטובוס',
        },
      },
      times: {
        header: 'זמן',
        fields: {
          hour: 'שעה',
          limit: 'הגבלה',
          busses: 'אוטובוסים',
          holidays: 'חגים',
        },
        btnAdd: 'הוסף זמן',
      },
      stops: {
        header: 'עצירות',
        fields: {
          address: 'כתובת',
          name: 'שם',
          zone: 'אזור',
          save: 'שמור',
        },
        btnAdd: 'הוסף עצירה',
      },
      zone: '(אזור: {{zone}})',
    },
    validation: {
      unitRequired: 'אתר נדרש',
      codeRequired: 'קוד נדרש',
      nameRequired: 'שם נדרש',
      paxRequired: 'נוסעים נדרשים',
      hourRequired: 'שעה נדרשת',
      limitRequired: 'הגבלה נדרשת',
      latRequired: 'קו רוחב נדרש',
      lonRequired: 'קו אורך נדרש',
    },
    weekDays: {
      sunday: 'יום ראשון',
      monday: 'יום שני',
      tuesday: 'יום שלישי',
      wednesday: 'יום רביעי',
      thursday: 'יום חמישי',
      friday: 'יום שישי',
      saturday: 'יום שבת',
    },
  },
};

export default shuttles;
